import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CSS } from "@dnd-kit/utilities";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../../Components/Common/Loader";
import { Button, Container, Row, Col, Table } from "reactstrap";
import { fetchCategoriesForSort, fetchSubCategoriesForSort } from "../../../lib/Apis";
import { useSearchParams } from "react-router-dom";

const SortableRow = ({ id, index, name }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
  };

  return (
    <tr ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <td className="fw-medium">{index + 1}</td>
      <td className="text-uppercase">{name}</td>
    </tr>
  );
};

const SubCategorySort = () => {
    const [searchParams] = useSearchParams();
      const parentId = searchParams.get("id");
  const [categoriesData, setCategoriesData] = useState([]);


  

 const {
      data: categories = [],
      isLoading: categoriesLoading = false,
      isError,
      error: categoriesError = false,
    } = useQuery({
      queryKey: ["categories",parentId ],
      queryFn: () => fetchSubCategoriesForSort(parentId),
    });
  
    useEffect(()=>{
        setCategoriesData(categories?.data ?? [])
    },[categories])
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = categoriesData.findIndex((cat) => cat._id === active.id);
    const newIndex = categoriesData.findIndex((cat) => cat._id === over.id);
    const newArray = arrayMove(categoriesData, oldIndex, newIndex);
    setCategoriesData(newArray);
  };

  

      
      

  const handleReorderSave = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const reorderedData = categoriesData.map((cat, index) => ({
        _id: cat._id,
        orderlist: index + 1,
      }));

      await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/category/order`,
        {orders:reorderedData},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success("Category order saved successfully!", {
        autoClose: 1000,
      });
    } catch (err) {
      toast.error("Something went wrong while saving.");
    }
  };

  if (categoriesLoading) return <Loader />;
  if (isError)
    return <h5 className="text-center mt-5 fw-normal">Error loading data</h5>;

  return (
    <Container
      fluid
      className="py-4 mt-5"
      style={{
        minHeight: "100dvh",
        backgroundColor: "#F6F9F9",
      }}
    >
      <ToastContainer />

      {categoriesData.length > 0 ? (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={categoriesData.map((cat) => cat._id)}
            strategy={verticalListSortingStrategy}
          >
            <Table bordered hover responsive className="bg-white mt-5 shadow-sm">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "60px" }}>#</th>
                  <th>Category Name</th>
                </tr>
              </thead>
              <tbody>
                {categoriesData.map((cat, idx) => (
                  <SortableRow
                    key={cat._id}
                    id={cat._id}
                    index={idx}
                    name={cat.name}
                  />
                ))}
              </tbody>
            </Table>
          </SortableContext>
        </DndContext>
      ) : (
        <h5 className="text-center mt-5 fw-normal">
          No categories available to sort
        </h5>
      )}

      {categoriesData.length > 0 && (
        <Row className="justify-content-center mt-4">
          <Col sm="auto">
            <Button color="success" onClick={handleReorderSave}>
              Save Order
            </Button>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default SubCategorySort;
